module.exports = __webpack_public_path__ + "img/album6-image-2.18184df8.jpg";